// extracted by mini-css-extract-plugin
module.exports = {"topHeader":"styles_topHeader__3nfhq","logo":"styles_logo__1D80T","item":"styles_item__1k-Xh","title-block":"styles_title-block__2EQ6Y","blackText":"styles_blackText__3X4jH"};